import { Helmet } from 'react-helmet-async';

interface MetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

const DEFAULTS = {
  title: 'GameDate — Find your perfect match through adventure',
  description: 'Join multiplayer rooms, build your character, and meet people through shared adventures.',
  image: 'https://gamedate.co.il/og-image.png',
  url: 'https://gamedate.co.il',
  type: 'website',
};

/**
 * Dynamic Open Graph / Twitter Card meta tags.
 * Wrap your app in <HelmetProvider> (in main.tsx) then drop <MetaTags> wherever needed.
 */
export function MetaTags({ title, description, image, url, type }: MetaTagsProps) {
  const t = title ?? DEFAULTS.title;
  const d = description ?? DEFAULTS.description;
  const img = image ?? DEFAULTS.image;
  const u = url ?? DEFAULTS.url;
  const tp = type ?? DEFAULTS.type;

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />

      {/* Open Graph */}
      <meta property="og:type" content={tp} />
      <meta property="og:site_name" content="GameDate" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={u} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
